import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import { useMutation } from 'react-query';
import {
  companySintegraCreate,
  companySintegraEdit,
  companySintegraGenerate,
  getCompanySintegra,
} from './Sintegra.services';

export function useCompanySintegraCreate() {
  const intl = useIntl();
  return useMutation(companySintegraCreate, {
    onSuccess() {
      notification.success({
        message: intl.formatMessage({
          id: 'employee.update.notification.success',
        }),
        description: 'Configuração do SINTEGRA criada',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCompanySintegraGenerate() {
  const intl = useIntl();
  return useMutation(companySintegraGenerate, {
    onSuccess() {
      notification.success({
        message: intl.formatMessage({
          id: 'employee.update.notification.success',
        }),
        description: 'Arquivo do SINTEGRA gerado',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useGetCompanySintegra() {
  return useMutation(getCompanySintegra, {
    onError(error) {
      notificationError(error);
    },
  });
}

export function useCompanySintegraEdit() {
  const intl = useIntl();
  return useMutation(companySintegraEdit, {
    onSuccess() {
      notification.success({
        message: intl.formatMessage({
          id: 'employee.update.notification.success',
        }),
        description: 'Configuração do SINTEGRA atualizada',
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
